import React from "react"

const SuccessNotification = ({ message }) => (
  <article className="message -success">
    <div className="message-body">{message}</div>
  </article>
)

const FailedNotification = ({ message }) => (
  <article className="message -danger">
    <div className="message-body">{message}</div>
  </article>
)

const SubmitNotification = ({ type, message }) => {
  if (type === "SUCCESS") {
    return (
      <SuccessNotification
        {...{
          message,
        }}
      />
    )
  }

  if (type === "FAILED") {
    return (
      <FailedNotification
        {...{
          message,
        }}
      />
    )
  }

  return ""
}

export default SubmitNotification
